import { Chip } from 'material-ui';
import React from 'react';

/**
 * 
 * @param {{ topics: string[] }} param0 
 * @returns 
 */
export default function Topics({ topics }) {

    return (
        <div className='topics'>
            { 
                topics.map((topic, index) => 
                    <Chip 
                        key={`${topic}_${index}`} 
                        className='topic' 
                        labelStyle={{ fontSize: '12px', lineHeight: '20px' }}
                        >
                            {topic}
                    </Chip>) 
            }
        </div>
    );
}



// WEBPACK FOOTER //
// ./app/components/Issues/List/Topics.jsx